export const rootUrl = "https://homolog.api.omnirota.vinhasoft.com.br/api/";
//export const rootUrl = "https://localhost:44348/api/";
export const apiCore = "https://homolog.api.omnicore.vinhasoft.com.br/api/";
//export const apiCore = "https://localhost:44392/api/";
export const apiAcount = "https://homolog.api.accounts.vinhasoft.com.br/api/v1";

export const environment = "Deployment";